import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import App from "./App.tsx";
import i18n from "./i18n";
import "./tailwind.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <QueryClientProvider client={new QueryClient()}>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </QueryClientProvider>
    </React.StrictMode>,
);
